import { Icon, IconProps } from "../";

export const VideoIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M152,1304 C152,1305.10457 151.104569,1306 150,1306 L140,1306 C138.895431,1306 138,1305.10457 138,1304 L138,1296 C138,1294.89543 138.895431,1294 140,1294 L150,1294 C151.104569,1294 152,1294.89543 152,1296 L152,1304 Z M157.800672,1296.11562 C157.930797,1296.31751 158,1296.55261 158,1296.79281 L158,1303.03894 C158,1303.7293 157.440356,1304.28894 156.75,1304.28894 C156.48493,1304.28894 156.226723,1304.20468 156.012677,1304.04832 L153.5,1302.213 L153.5,1297.4 L156.072809,1295.74213 C156.653079,1295.36813 157.42667,1295.53535 157.800672,1296.11562 Z"
        transform="translate(-136 -1288)"
      />
    </Icon>
  );
};
